import { render, staticRenderFns } from "./DepartmentSelect.vue?vue&type=template&id=040d5b41&scoped=true&"
import script from "./DepartmentSelect.vue?vue&type=script&lang=js&"
export * from "./DepartmentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d5b41",
  null
  
)

export default component.exports